<template>
  <div class="card">
    <div class="card-header pb-0">
      <h6>Members : {{this.users.length}} คน</h6>
      <select  v-model="selected_filter" data-toggle="selected_filter" @change="onSelectedFilter()">
        <option value="all"    >All</option>
        <option value="expired" >Expired</option>
        <option value="expiring">Expiring (5 Days)</option>
        <option value="active"  >Active</option>
      </select>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0" >
        <table class="table align-items-center mb-0" >
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"><button @click="sort_line_clicked()">Line Display / UID</button></th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              ><button @click="sort_ref_clicked()">Referrer</button></th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              ><button @click="sort_type_clicked()">Type</button></th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >จำนวนเติม</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >วันที่เติม</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              ><button @click="sort_status_clicked()">Status</button></th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in orderedUsers" :key="user.username">
            <!-- <tr v-for="(user, index) in users" :key="index"> -->
              <td>
                <div class="d-flex px-2 py-1">
                  <!-- <div>
                    <img
                      src="../../assets/img/team-1.jpg"
                      class="avatar avatar-sm me-3"
                      alt="user1"
                    />
                  </div> -->
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{user.line_display}}</h6>
                    <p class="text-xs text-secondary mb-0">{{user.username.slice(0,15) + " .."}}</p>
                  </div>
                </div>
              </td>
              <td>
                <p class="text-xs font-weight-bold mb-0">{{user.ref_str}}</p>
                <!-- <p class="text-xs text-secondary mb-0">Organization</p> -->
              </td>
              <td class="align-middle text-center text-sm">
                <span class="text-secondary text-xs font-weight-bold">{{user.type_str}}</span>
              </td>
              <td class="align-middle text-center text-sm">
                <span class="text-secondary text-xs font-weight-bold">{{user.total_amount}}</span>
              </td>
              <td class="align-middle text-center">
                <span v-if="user.paid_timestamp!=undefined" class="text-secondary text-xs font-weight-bold">{{new Date(user.paid_timestamp).toLocaleDateString('th-TH')}}</span>
                <span v-else class="text-secondary text-xs font-weight-bold">-</span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{new Date(user.expire_date).toLocaleDateString('th-TH')  }} ({{user.balance_days}})</span>
              </td>
              <td class="align-middle">
                <a
                  href="javascript:;"
                  class="text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="Edit user"
                >Edit</a>
              </td>
            </tr> 

          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
const qs = require('querystring')
var host_api=window.localStorage.getItem('$host_api');

export default {
  name: "authors-table",
  props:{
    uid:String
  },
  data() {
    return {
      users : [],
      all_users : [],
      username : "admin_jay",
      sort_type : 0,
      selected_filter : 'all'
    }
  },
  methods :{ 

    onSelectedFilter() {
      console.log("SEL : " + this.selected_filter)
      this.users.forEach(user => {
        
      });
    },
    reload_users(){           
      host_api=window.localStorage.getItem('$host_api');
      const config = {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
      const requestBody = {
      }

      axios.post(host_api+"/admin/users/all", qs.stringify(requestBody), config,
        ).then(response => {
            if (response.data.status == "success") {
              // this.users = response.data.users
              if (this.uid != null && this.uid != '' && this.uid != undefined) {
                console.log('yes')
                response.data.users.forEach(user => {
                  if (user.ref_username == this.uid) {
                    user.balance_days = this.check_usage_days(user.expire_date) 
                    if (user.type == 0 )
                      user.type_str = "Member"
                    else if (user.type == 1)
                      user.type_str = "Influencer"
                    else 
                      user.type_str = "Unknown"
                    
                    if (user.line_display == '' || user.line_display == null || user.line_display == undefined) {
                      user.line_display = "[No Display]"
                      if (user.line_display.length > 15)
                        user.line_display = user.line_display.slice(0,15) + '..'
                    }

                    response.data.users.forEach(ref => {
                      if (user.ref_username == ref.username)
                        user.ref_str = ref.line_display
                    });
                    this.users.push(user)
                  }
                });
                this.all_users = this.users
                console.log("All : " +  this.all_users.length)
              } else { 
                console.log("no")
                response.data.users.forEach(user => {
                  user.balance_days = this.check_usage_days(user.expire_date) 
                  if (user.type == 0 )
                    user.type_str = "Member"
                  else if (user.type == 1)
                    user.type_str = "Influencer"
                  else 
                    user.type_str = "Unknown"
                  
                  if (user.line_display == '' || user.line_display == null || user.line_display == undefined) {
                    user.line_display = "[No Display]"
                  } else if  (user.line_display.length > 15) {
                    user.line_display = user.line_display.slice(0,15) + '..'
                  }

                  response.data.users.forEach(ref => {
                    if (user.ref_username == ref.username)
                      user.ref_str = ref.line_display
                  });
                  this.users.push(user)
                });
                this.all_users = this.users
                console.log("All : " +  this.all_users.length)
              }
            }
            else {
                console.log("False")
            }
        })
    }, 
    check_usage_days (expire_date) {
      var today =new Date()
      var lastday = new Date(expire_date)
      var difference = Math.floor((lastday - today) / (1000*60*60*24))
      difference = difference + 1
      if (difference < 0 )
        return 'expired'
      return difference + ' วัน'
    },
    check_expiring (expire_date) {
      var today =new Date()
      var lastday = new Date(expire_date)
      var difference = Math.floor((lastday - today) / (1000*60*60*24))
      difference = difference 
      if (difference >= 0 && difference < 5)
        return true
      return false
    },
    sort_ref_clicked (){
      this.sort_type = 1
    },
    sort_line_clicked (){
      this.sort_type = 0
    },
    sort_status_clicked (){
      this.sort_type = 2
    },
    sort_type_clicked (){
      this.sort_type = 3
    }
  },
  created() {

    var temp_users = this.$store.state.memo


    temp_users.forEach(user => {
      user.balance_days = this.check_usage_days(user.expire_date) 
      if (user.type == 0 )
        user.type_str = "Member"
      else if (user.type == 1)
        user.type_str = "Influencer"
      else 
        user.type_str = "Unknown"
      
      if (user.line_display == '' || user.line_display == null || user.line_display == undefined) {
        user.line_display = "[No Display]"
        if (user.line_display.length > 15)
          user.line_display = user.line_display.slice(0,15) + '..'
      }
      if (user.total_amount == undefined) {
        user.total_amount = 0
      }

      temp_users.forEach(ref => {
        if (user.ref_username == ref.username)
          user.ref_str = ref.line_display
      });
      this.users.push(user)
  });
  this.all_users = this.users
  console.log("All : " +  this.all_users.length)
    // this.users= JSON.parse(localStorage.getItem('memo'))
    // console.log(this.users);
  // this.reload_users();
  }, 
  computed: {
    orderedUsers : function() {
        console.log('sort');
      if (this.selected_filter == 'expired') {
        console.log('logic expired')
        var temp_users = []
        this.all_users.forEach(user => {
          if (this.check_usage_days(user.expire_date) == 'expired')
            temp_users.push(user)
        });
        this.users = temp_users
        console.log(this.users.length)
      } else if (this.selected_filter == 'expiring') {
        console.log('logic expiring')
        var temp_users = []
        this.all_users.forEach(user => {
          if (this.check_expiring(user.expire_date))
            temp_users.push(user)
        });
        this.users = temp_users
        console.log(this.users.length)
      } else if (this.selected_filter == 'active') {
        console.log('logic active')
        var temp_users = []
        this.all_users.forEach(user => {
          if (this.check_usage_days(user.expire_date) != 'expired')
            temp_users.push(user)
        });
        this.users = temp_users
        console.log(this.users.length)
      } else if (this.selected_filter == 'all') {
        this.users = this.all_users
        console.log(this.users.length)
      }


      if (this.sort_type == 0 )
        return this.users.sort((a, b) => a.line_display > b.line_display ? 1 : -1);
      else if (this.sort_type == 1 )
        return this.users.sort((a, b) => a.ref_str > b.ref_str ? 1 : -1);
        // return this.users.sort((a, b) => a.ref_str > b.ref_str ? 1 : -1);
      else if (this.sort_type == 2 )
        return this.users.sort((a, b) => a.expire_date > b.expire_date ? 1 : -1);
      else if (this.sort_type == 3 )
        return this.users.sort((a, b) => a.type > b.type ? 1 : -1);
    }
}
};

</script>
